import { render, staticRenderFns } from "./ClientPropertyPicker.vue?vue&type=template&id=472dc56b&scoped=true&"
import script from "./ClientPropertyPicker.vue?vue&type=script&lang=js&"
export * from "./ClientPropertyPicker.vue?vue&type=script&lang=js&"
import style0 from "./ClientPropertyPicker.vue?vue&type=style&index=0&id=472dc56b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dc56b",
  null
  
)

export default component.exports